// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1330":"eae75ff7e905fed8","5367":"634992f46a61c2bd"}[chunkId] + ".js";
};